import { render } from "./AboutPopup.vue?vue&type=template&id=f4a078d4&scoped=true"
import script from "./AboutPopup.vue?vue&type=script&lang=js"
export * from "./AboutPopup.vue?vue&type=script&lang=js"

import "./AboutPopup.vue?vue&type=style&index=0&id=f4a078d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a078d4"]])

export default __exports__